import React from 'react';
import { highlighterFor } from '../../lib/paper';

/** A tag in its own highlighter colour — the same tag is the same colour everywhere. */
export const TagPill: React.FC<{ label: string; className?: string }> = ({ label, className = '' }) => {
  const tone = highlighterFor(label);
  return (
    <span
      className={`inline-block max-w-[12rem] -rotate-1 truncate rounded-full px-2.5 py-0.5 font-body text-[0.6875rem] font-semibold leading-4 ${className}`}
      style={{ backgroundColor: tone.fill, color: tone.ink }}
    >
      {label}
    </span>
  );
};
